import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetWellnessDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_WELLNESS_DETAILS, token);
  return res;
};

export const GetWellnessDetail = async (wellnessId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_WELLNESS_DETAILS_BY_ID + wellnessId,
    token
  );
  return res;
};

export const AddWellness = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_WELLNESS, payload, token);
  return res;
};

export const DeleteWellness = async (wellnessId) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(
    Url.DELETE_WELLNESS + wellnessId,
    wellnessId,
    token
  );
  return res;
};

export const UpdateWellness = async (wellnessId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(
    Url.UPDATE_WELLNESS + wellnessId,
    payload,
    token
  );
  return res;
};
